import React from 'react';
import PropTypes from 'prop-types';
import Box from '@material-ui/core/Box';
import Typography from '@material-ui/core/Typography';
import Link from '@material-ui/core/Link';
import Container from 'common/Container';
import { useTheme } from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid';
import { LEILA_PORTRAIT_SRC } from '../brandAssets';
import { legalmenteForegroundOnPage } from '../legalmenteReadableText';

const Who = ({ themeMode = 'light' }) => {
  const theme = useTheme();
  const headingColor = legalmenteForegroundOnPage(theme);

  return (
    <Box>
      <Box marginBottom={4}>
        <Container
          sx={{
            backgroundImage:
              themeMode === 'dark'
                ? 'url(/images/logos/logo_white.PNG)'
                : 'url(/images/logos/logo_tnonetwork_black.png)',
            backgroundRepeat: 'no-repeat',
            backgroundPosition: 'center',
            backgroundSize: 'contain',
            height: '20vh',
          }}
        />
        <Box
          component={Typography}
          fontWeight={700}
          variant="h3"
          gutterBottom
          align="center"
          sx={{ fontFamily: 'Georgia, "Times New Roman", serif', color: headingColor }}
        >
          Legalmente en Familia: la brújula legal de la familia venezolana
        </Box>
        <Typography variant="h6" component="p" color="textSecondary" align="center">
          Un espacio para la alfabetización legal y la educación jurídica preventiva. Traducimos el marco legal en
          acciones claras para el hogar, la salud y la seguridad en entornos digitales y presenciales. Tu marca se
          asocia a ética, protección y propósito.
        </Typography>
        <Typography
          variant="h5"
          component="p"
          color={theme.palette.secondary.main}
          align="center"
          sx={{ mt: 3, mb: 2, fontStyle: 'italic', fontFamily: 'Georgia, "Times New Roman", serif' }}
        >
          Informar para salvar y proteger
        </Typography>
        <Typography align="center" sx={{ mb: 1 }}>
          <Link
            href="https://www.tnonetwork.com/show/legalmenteenfamilia"
            target="_blank"
            rel="noopener noreferrer"
            underline="hover"
            sx={{
              color: headingColor,
              '&:hover': { color: theme.palette.secondary.main },
            }}
          >
            tnonetwork.com/show/legalmenteenfamilia
          </Link>
        </Typography>
        <Typography variant="body1" component="p" color="textSecondary" align="center" sx={{ mt: 1 }}>
          Transmisión en vivo todos los <strong>lunes a las 12:00 PM</strong> en la primera radio visual de Venezuela,
          con respaldo On-Demand en la plataforma TNO Network. Síguenos en{' '}
          <Link
            href="https://www.instagram.com/legalmenteenfamilia/"
            target="_blank"
            rel="noopener noreferrer"
            underline="hover"
            sx={{
              color: headingColor,
              '&:hover': { color: theme.palette.secondary.main },
            }}
          >
            @legalmenteenfamilia
          </Link>
          .
        </Typography>
      </Box>

      <Box marginTop={6} marginBottom={4}>
        <Grid container spacing={4} alignItems="center">
          <Grid item xs={12} md={3}>
            <Box display="flex" justifyContent="center">
              <Box
                component="img"
                src={LEILA_PORTRAIT_SRC}
                alt="Leila Davogustto Luna — Legalmente en Familia"
                sx={{
                  width: { xs: 200, sm: 250, md: 300 },
                  height: { xs: 200, sm: 250, md: 300 },
                  borderRadius: 2,
                  objectFit: 'cover',
                  boxShadow: 3,
                  border: `3px solid ${theme.palette.secondary.main}`,
                }}
              />
            </Box>
          </Grid>
          <Grid item xs={12} md={9}>
            <Typography
              variant="h5"
              fontWeight={700}
              gutterBottom
              sx={{ fontFamily: 'Georgia, "Times New Roman", serif', color: headingColor }}
            >
              NUESTRA ANCLA: LEILA DAVOGUSTTO LUNA
            </Typography>
            <Typography variant="body2" color="textSecondary" sx={{ fontStyle: 'italic', mb: 2 }}>
              Autoridad y ética inquebrantable — líder de opinión en derechos familiares.
            </Typography>
            <Typography variant="body1" color="textSecondary">
              <strong>Leila Davogustto Luna</strong> conduce <strong>Legalmente en Familia</strong> con una mirada que
              une trayectoria institucional y cercanía con la audiencia. Más que una conductora, es referencia en
              protección infantil, distinción académica y voz en el debate empresarial y social — el contexto ideal
              para marcas que buscan <strong>brand safety</strong> y conversación de alto valor.
            </Typography>
          </Grid>
        </Grid>
      </Box>
    </Box>
  );
};

Who.propTypes = {
  themeMode: PropTypes.string.isRequired,
};

export default Who;
